import classNames from 'classnames';
import React, { Fragment } from 'react';

import FontIcon from '@/shared/ui/FontIcon';

import '@/workchat/v3/components/WorkChatListItem/WorkChatListItem.scss';

interface WorkChatListItemProps {
  testId: string;
  asButton?: boolean;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  slotPrimary?: React.ReactNode;
  slotContent?: React.ReactNode;
  hideChevron?: boolean;
}

export default React.memo(function WorkChatListItem({
  testId,
  asButton,
  className,
  ariaLabel,
  disabled,
  onClick,
  slotPrimary,
  slotContent,
  hideChevron,
}: WorkChatListItemProps) {
  const slots = (
    <Fragment>
      <div className="slot-primary">{slotPrimary}</div>
      <div className="slot-content">{slotContent}</div>
      <div className="slot-icon">{!hideChevron && <FontIcon icon="chevron-right" srText={ariaLabel} />}</div>
    </Fragment>
  );

  if (asButton) {
    return (
      <li data-testid={testId} className={classNames(`WorkChatListItem ${className || ''}`)}>
        <button
          type="button"
          aria-label={ariaLabel}
          onClick={event => onClick?.(event)}
          disabled={disabled}
          className={classNames(`WorkChatListItemButton`, { disabled })}
        >
          {slots}
        </button>
      </li>
    );
  }

  return <li className={classNames(`WorkChatListItem ${className || ''}`)}>{slots}</li>;
});
